import {Inputs, useEffect, useRef} from "preact/hooks";

export function useTimeout(callback: () => void, timeout: number, inputs: Inputs = []) {
    const cbRef = useRef(callback);

    useEffect(() => {
        cbRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const tm = window.setTimeout(() => {
            cbRef.current()
        }, timeout);

        return () => {
            window.clearTimeout(tm);
        };
    }, [timeout, ...inputs]);
}
